import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";

const DownloadModal = ({
  fileSize,
  uniqueTxnId,
  checkForCSRFTokenInfo,
  modalContent,
  fileFormat,
  ...props
}) => {
  const { ccpaFlow, amUUId, loggedInMdn, amAccountNumber, amVZId, amComVZId } = window.reactGlobals;
  const isUnregistered =
    ccpaFlow &&
    typeof ccpaFlow === "string" &&
    (ccpaFlow.toLowerCase() === "guest" ||
      ccpaFlow.toLowerCase() === "ivr_unregistered" ||
      ccpaFlow.toLowerCase() === "former" ||
      ccpaFlow.toLowerCase() === "wireline_unregistered");

  const actionUrl = isUnregistered
    ? "/privacy/your-data/api/download/file"
    : "/privacy/secure/api/download/file";

  const unregisteredPostParams = isUnregistered && (
    <Fragment>
      <input hidden type="text" name="AM_UUID" readOnly value={amUUId} />
      <input hidden type="text" name="AM_CCPA_FLOW" readOnly value={ccpaFlow} />
      <input hidden type="text" name="VPD_CCPA_FLOW" readOnly value={ccpaFlow} />
      <input hidden type="text" name="AM_MOBILE_NUMBER" readOnly value={loggedInMdn} />
      <input hidden type="text" name="AM_ACCOUNT_NUMBER" readOnly value={amAccountNumber} />
      <input hidden type="text" name="AM_VZID" readOnly value={amVZId} />
      <input hidden type="text" name="AM_COMVZID" readOnly value={amComVZId} />
    </Fragment>
  );
  const fileFormatObject = modalContent.genericList[0].list[0];
  return (
    <Modal contentLabel="download file information modal">
      <h2 style={{ marginBottom: "24px" }}>{modalContent.section_title}</h2>
      <Div>{convertStringToElements(modalContent.section_description)}</Div>
      <div style={{ marginTop: "24px" }}>
        <P>
          <strong>{fileFormatObject.jsonKey}</strong> .{fileFormat.toUpperCase()}{" "}
          {fileFormat.toUpperCase() === "XLSX" || fileFormat.toUpperCase() === "XLS"
            ? fileFormatObject.excelValue
            : fileFormatObject.jsonValue}
        </P>
        <P style={{ marginBottom: "34px" }}>
          <strong>{modalContent.genericList[0].list[1].jsonKey}</strong> {fileSize}
        </P>
        <form action={actionUrl} method="post" encType="application/x-www-form-urlencoded">
          {unregisteredPostParams}
          <input hidden type="text" name="uniqueTxnId" readOnly value={uniqueTxnId} />
          <input hidden type="text" name="csrfTokenInfo" readOnly value={checkForCSRFTokenInfo()} />
          <Button type="submit" background={modalContent.buttons[0].type}>
            {modalContent.buttons[0].text}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default DownloadModal;

DownloadModal.propTypes = {
  fileSize: PropTypes.string.isRequired,
  uniqueTxnId: PropTypes.string.isRequired,
  checkForCSRFTokenInfo: PropTypes.func.isRequired,
  modalContent: PropTypes.object.isRequired
};

const P = styled.p`
  margin-bottom: 10px;
`;

const Div = styled.div`
  max-width: 466px;

  p {
    margin: 15px 0;
  }
`;
